import Article from './articles';

export default Article;
